import { RSAA } from 'redux-api-middleware';
import { selectedOfferSelectors } from '@makemydeal/dr-shared-store';
import type { BffApiUrlResult } from '@makemydeal/dr-shared-ui-utils';
import { apiConfigHelper, locHrefUtil, MANAGER_VIEW_APP_PREFIX } from '@makemydeal/dr-shared-ui-utils';
import { getCurrentAxiosRequestInterceptor } from '@makemydeal/dr-shared-network';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
// external
import axios from 'axios';
import {
    DEAL_CHANGE_LOG_REQUEST,
    DEAL_CHANGE_LOG_FAILURE,
    DEAL_CHANGE_LOG_SUCCESS,
    DOWNLOAD_AUDIT_LOG_REQUEST,
    DOWNLOAD_AUDIT_LOG_SUCCESS,
    DOWNLOAD_AUDIT_LOG_FAILURE
} from '../actionTypes/dealAuditLogActionTypes';
import { getDownloadAuditLogPayload } from '../selectors/dealAuditLogSelectors';
import { getBlobFromBase64 } from '../utils/formatUtils';
import {
    BASE64_STRING_VALIDATION_REGEX,
    BASE64_STRING_ERROR_MESSAGE,
    DOWNLOAD_AUDIT_LOG_MISSING_URL_ERROR_MESSAGE
} from '../constants';

export const fetchDealChangeLog = () => (dispatch: any, getState: any) => {
    const state = getState();
    const dealId = selectedOfferSelectors.getSelectedOfferDealXgId(state);

    // Return if dealId is undefined
    if (!dealId) {
        return;
    }
    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult: BffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '');
    const endpoint = `${bffApiUrlResult.url}/audit-log/${dealId}`;

    dispatch({
        [RSAA]: {
            endpoint: endpoint,
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            types: [DEAL_CHANGE_LOG_REQUEST, DEAL_CHANGE_LOG_SUCCESS, DEAL_CHANGE_LOG_FAILURE]
        }
    });
};

export const downloadAuditLog = () => async (dispatch: any, getState: any) => {
    const state = getState();
    const downloadAuditLogPayload = getDownloadAuditLogPayload(state);
    if (!downloadAuditLogPayload) {
        return;
    }

    const locHref = locHrefUtil.getLocHref();
    const bffApiUrlResult: BffApiUrlResult = apiConfigHelper.buildBffApiUrl(MANAGER_VIEW_APP_PREFIX, locHref, '');
    const endpoint = `${bffApiUrlResult.url}/generatePdfAuditLog`;

    const axiosRequestInterceptor = getCurrentAxiosRequestInterceptor();
    const { headers } = await axiosRequestInterceptor({ url: endpoint });

    try {
        const response = await axios.post(
            endpoint,
            { ...downloadAuditLogPayload },
            {
                headers: {
                    Authorization: headers.Authorization
                }
            }
        );
        const base64 = response?.data?.data?.url;
        if (!base64) {
            throw new Error(DOWNLOAD_AUDIT_LOG_MISSING_URL_ERROR_MESSAGE);
        }
        if (!BASE64_STRING_VALIDATION_REGEX.test(base64)) {
            throw new Error(BASE64_STRING_ERROR_MESSAGE);
        }
        const blob = getBlobFromBase64(base64);
        const blobUrl = URL.createObjectURL(blob);
        const newTab = window.open(blobUrl, '_blank');
        if (newTab && typeof newTab.focus === 'function') {
            newTab.focus();
        }

        dispatch({ type: DOWNLOAD_AUDIT_LOG_SUCCESS });
    } catch (err) {
        logNewRelicPageAction('MV:AuditLog:downloadAuditLog:failure', {
            errorMessage: err instanceof Error ? err.message : String(err)
        });
        dispatch({ type: DOWNLOAD_AUDIT_LOG_FAILURE });
    }
};

export const startDownloadSpinner = (version: string) => {
    return {
        type: DOWNLOAD_AUDIT_LOG_REQUEST,
        payload: { version }
    };
};
